import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, useWatch } from 'react-hook-form';

import swal from 'sweetalert';

import { 
    Stack,
    Step, 
    StepButton, 
    Stepper
} from '@mui/material';

import { Encabezado } from '../../Components/Encabezado/Encabezado'
import { RegistroCombosComidaRRHHPage } from '../../Components/Cafetería/Page/RegistroCombosComidaRRHHPage';
import { EditarComboModal } from '../../Components/Cafetería/Modal/EditarComboModal';

import { 
    selectDiasAlmuerzo,
    selectSemanaAlmuerzoById,
    selectCategoriasAlmuerzoListadoComidas,
    selectCombosSemanaById,
    selectIsLoading,
    fetchGetSemanaAlmuerzoById,
    fetchGetDiasAlmuerzo,
    fetchGetCategoriasAlmuerzoListadoComidas,
    fetchGetCombosSemanaById,
    fetchCambiarSuccess,
    selectIsSuccess,
    selectMessage
} from '../../redux/Cafeteria/CafeteriaSlice';
import { removeAccents } from '../../utils';

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import Loading from '../../Components/Modals/Loading/Loader';

export const DigitarListadoCombosComida = () => {
  
    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // ? HOOK-NAVIGATE
    const navigate = useNavigate();

    // * DESESTRUCTURACION DEL ESTADO DEL HOOK.
    const { state: id = 0 } = useLocation();

    // * VALIDACIONES DEL HOOK-FORM PARA LAS CONTRASEÑAAS.
    const formSchema = Yup.object().shape({
        guarnicion: Yup.object(),
        acompañamiento: Yup.object(),
        ensalada: Yup.object(),
        numeracion: Yup.number().required("El campo es requerido")
                                .transform((value, originalValue) => (originalValue === "" ? NaN : value)) // Evita que "" se convierta en NaN automáticamente
                                .typeError("Debe ingresar un número válido") // Si no es un número, muestra este mensaje
                                .notOneOf([0], "El valor no puede ser 0, favor ingresar un número válido.")
                                ,
        combos: Yup.object().shape({
            lunes: Yup.array(),
            martes: Yup.array(),
            miercoles: Yup.array(),
            jueves: Yup.array(),
            viernes: Yup.array(),        
        }),
        comboEdit: Yup.object().shape({
            guarnicion: Yup.object(),
            acompañamiento: Yup.object(),
            ensalada: Yup.object(),    
        })
    });

    // ? HOOK-FORM
    const form = useForm({
        defaultValues: {
            guarnicion: {},
            acompañamiento: {},
            ensalada: {},
            numeracion: 1,
            combos: {
                lunes: [],
                martes: [],
                miercoles: [],
                jueves: [],
                viernes: []
            },
            comboEdit: {
                guarnicion: {},
                acompañamiento: {},
                ensalada: {},
            }
        },
        resolver: yupResolver(formSchema)
    });

    // ? DESESTRUCTURACION DE HOOK-FORM
    const { setValue, control, watch, reset } = form;

    // ? HOOK-WATCH
    const combosWatch = useWatch({
        control,
        name: "combos",
    })

    // ? HOOK-SELECTOR
    const semana = useSelector(selectSemanaAlmuerzoById);
    const diasSemanas = useSelector(selectDiasAlmuerzo);
    const categoriasComidas = useSelector(selectCategoriasAlmuerzoListadoComidas);
    const combosSemanaById = useSelector(selectCombosSemanaById);
    const isLoading = useSelector(selectIsLoading);
    const success = useSelector(selectIsSuccess);
    const message = useSelector(selectMessage);

    // ? HOOK-STATE PARA LA PAGINACION DE PAGINAS.
    const [stepPosition, setStepPosition] = useState({position: 0, diaId: 1, diaNormalized: ''}); 

    // ? HOOK STATE PARA ALMACENAR LOS DIAS DE LUNES A VIERNES Y ADICIONAL EL RESUMEN DEL MENU SEMANAL.
    const [diasSemanaState, setDiasSemanaState] = useState([]); 
    const [categoriasComidasState, setCategoriasComidasState] = useState([]); 
    const [addNewItemComida, setAddNewItemComida] = useState({});
    const [openEditComida, setOpenEditComida] = useState({open: false, combo: {}});


    // * -------------------------------- * //
    // * ---------- FUNCIONES ----------- * //
    // * -------------------------------- * //

    // * FUNCION PARA REFRESCAR TODAS LAS LISTAS
    const refreshAll = () => {
        dispatch(fetchGetDiasAlmuerzo());
        dispatch(fetchGetCategoriasAlmuerzoListadoComidas());
        dispatch(fetchGetSemanaAlmuerzoById(id));
        dispatch(fetchGetCombosSemanaById({semanaId: id, enabledComboNoAplica: false}));
    }

    // * FUNCION PARA AGREGAR UNA NUEVA COMIDA SEGUN LA CATEGORIA EN QUE SE ENCUENTRE.
    const funcAgregarNuevaComida = ({value, categoriaAlmuerzoId, editCombo = false}) => {
        const addNew = {id: Math.random(), descripcion: value, categoriaAlmuerzoId, nuevo: true, editCombo};
        setAddNewItemComida(addNew)
    }

    // * FUNCION PARA ACTUALIZAR UN COMBO SELECCIONADO DE UN DIA X.
    const funcUpdateComboSelected = ({diaNormalized = ''}) => {

        // * DESESTRUCTURACION DE DATOS
        const { comboEdit : { guarnicion, acompañamiento, ensalada, numeracion } } = watch();

        // * COPIA DEL ARRAY DE LOS CAMBOS DEL DIA SELECCIONADO.
        const data = [...combosWatch[diaNormalized]];

        // * VALIDACION DONDE SE VERIFICA QUE EL OBJETO TENGA ALGUN VALOR PARA EVITAR
        // * MANDAR UN ARRAY VACIO.
        if(Object.values(watch('comboEdit')).every(combo => Object.keys(combo).length === 0) )
        {
            swal("Error", "Debe seleccionar una comida por lo menos.", "error");
            return;
        }

        // * ARRAY PARA GUARDAR LOS NUEVOS CAMBIOS.
        let arrComboUpdate = [];

        for (let i = 0; i < data.length; i++) {
            let combo = data[i];

            if(combo.numeracion === numeracion){
                combo.comidas =  [ guarnicion, acompañamiento, ensalada];
            }

            arrComboUpdate.push(combo);
        }

        // * ACTUALIZANDO OPCIONES DEL MENU.
        setValue(`combos.${diaNormalized}`, arrComboUpdate);

        swal("Exitoso!", `El combo #${numeracion} fue acualizado correctamente.`, "success", {
            timer: 1000,
        });
    }


    // * --------------------------------- * //
    // * ---------- USE-EFFECT ----------- * //
    // * --------------------------------- * //

    useEffect(() => {
    
        if(id === 0){
            navigate('/cafeteria/semanasAlmuerzo');
        }
        else{
            refreshAll();
        }
    
    }, [id])

    // ? HOOK-EFFECT PARA CARGAR TODOS LOS LISTADOS.
    useEffect(() => {
        refreshAll();
    }, [])


    // ? HOOK-EFFECT PARA AÑADIR UN NUEVO DIA DE SEMANA QUE ES EL RESUMEN DE LA SELECCION.
    useEffect(() => {
        setDiasSemanaState([...diasSemanas, { id: 6, descripcion: "RESUMEN DE LA SELECCIÓN"}]);
    }, [diasSemanas])
  
    useEffect(() => {
      setCategoriasComidasState(categoriasComidas);
    }, [categoriasComidas])

    // ? HOOK-EFFECT QUE FUNCIONA PARA AGREGAR UNA NUEVA COMIDA CON SU CATEGORIA AGREGADA POR EL USUARIO
    useEffect(() => {
          
        if(Object.keys(addNewItemComida).length > 0){
    
            const { categoriaAlmuerzoId } = addNewItemComida;
        
            const { descripcion, comidas } = categoriasComidas.find(x => x.id === categoriaAlmuerzoId);

            const categoriaNormalized = descripcion?.toLowerCase() === "acompañamiento" ? descripcion?.toLowerCase() : removeAccents(descripcion?.toLowerCase());
        
            const optionsUpdate = [...comidas, addNewItemComida];

            const dedupeBy = (arr, keyFn) => {
                const map = new Map();
                for (const x of arr) map.set(keyFn(x), x);
                return Array.from(map.values());
            };

            setCategoriasComidasState(prev =>
            prev.map(item =>
                item.descripcion === descripcion
                ? {
                    ...item,
                    comidas: dedupeBy(
                        [...item.comidas, ...optionsUpdate],
                        (x) => x.id // deduplicar por id
                    ),
                    }
                : item
                )
            );

            // * SIRVE PARA ASIGNAR VALOR AL OBJECTO DE COMBO-EDIT, SOLAMENTE AFECTA A LOS COMBOS 
            // * PREVIAMENTES AGREGADOS Y SE REQUIERE EDITAR UN COMBO EXISTENTE.
            if(addNewItemComida?.editCombo){
                setValue(`comboEdit.${categoriaNormalized}`, addNewItemComida)
            }
            else{
                setValue(categoriaNormalized, addNewItemComida)
            }
        }
        
    }, [addNewItemComida])

    // ? HOOK-EFFECT PARA SWEET-ALERT
    useEffect(() => {

        if (success === "success" && message.length > 0) {
            swal("Exitoso!", message, "success", {
                timer: 1200,
            });

            // * RESET STATE.
            setStepPosition({position: 0, diaId: 1});
            dispatch(fetchCambiarSuccess());
            
            // * REFRESCAR TODAS LAS LISTAS NUEVAMENTE.
            refreshAll();
        } 
        else if (success === "error") {
            swal("Error", message, "error", {
                timer: 5000
            });

            dispatch(fetchCambiarSuccess());
        }
    }, [success]);
    
    // ? HOOK-EFFECT PARA CARGA LA DATA DE SELECCION DE COMBOS EN CASO DE QUE EXISTA.
    useEffect(() => {

        if(combosSemanaById.length > 0){

            let seleccionCombos = {};

            for (let i = 0; i < combosSemanaById.length; i++) {
                const { combos, descripcion } = combosSemanaById[i];

                const diaNormalized = removeAccents(descripcion).toLocaleLowerCase();

                seleccionCombos = {...seleccionCombos, [diaNormalized]: []};

                seleccionCombos[diaNormalized] = combos;
            }

            setValue('combos', seleccionCombos);
            return;
        }

        reset();
    }, [combosSemanaById])

    // ? HOOK-EFFECT PARA ASIGNAR LOS VALORES DEL COMBO SELECCIONADO EN EL HOOK-FORM PARA SER EDITADO.
    useEffect(() => {
      
        if(Object.keys(openEditComida.combo).length > 0){

            // * DESESTRUCTURACION DE LOS DATOS
            const { comidas = [] } = openEditComida.combo;

            // * OBJETO ACTUALIZADO
            let comboUpdated = {
                guarnicion: {},
                acompañamiento: {},
                ensalada: {},
                numeracion: openEditComida.combo.numeracion
            }

            for (let i = 0; i < comidas.length; i++) {
                const comida = comidas[i];
                
                switch (comida.categoriaAlmuerzoId) {
                    case 1:
                        comboUpdated.guarnicion = comida;
                        break;
                    
                    case 2:
                        comboUpdated.acompañamiento = comida;
                        break;
                    
                    case 3:
                        comboUpdated.ensalada = comida;
                        break;

                    default:
                        break;
                }

            }

            setValue('comboEdit', comboUpdated);
        }

    }, [openEditComida])


    // * COMPONENTE PARA ACTUALIZAR LA PAGINA SEGUN EL DIA ELEGIDO.
    const HandleSteps = ({ position : {diaId, position}}) => {      

        let children = <></>;

        if(diasSemanaState.length > 0){
    
            // * VARIABLE CON EL DIA NORMALIZADO.
            const diaNormalized = removeAccents(diasSemanaState.find(x => x.id === diaId)?.descripcion).toLowerCase() ?? "";

            // * COMBOS FILTRADOS POR EL DIA SELECCIONADO.
            const dataFilterDay = combosWatch[diaNormalized];

            children = 
            <RegistroCombosComidaRRHHPage 
            categoriasComidasState={categoriasComidasState} 
            form={form}
            stepPosition={stepPosition}
            setStepPosition={setStepPosition}
            diasSemanas={diasSemanaState}
            setAddNewItemComida={setAddNewItemComida}
            combosWatch={position < 5 ? dataFilterDay : combosWatch}
            openEditComida={openEditComida}
            setOpenEditComida={setOpenEditComida}
            funcAgregarNuevaComida={funcAgregarNuevaComida}
            funcUpdateComboSelected={funcUpdateComboSelected}
            semanaId={id}
            />
        }

        return children;
    };
    
    return (
        <Encabezado title={`Selección de Comida - ${semana?.semanaLabel}`}>
            <Stack>
                <Stepper alternativeLabel activeStep={combosSemanaById.length > 0 ? 6 : stepPosition.position}>
                
                {
                    diasSemanaState.length > 0 &&
                        diasSemanaState.map((item, index) =>

                            <Step key={index}>
                                <StepButton onClick={() => setStepPosition({position: index, diaId: item.id})}>
                                    {item.descripcion}
                                </StepButton>
                            </Step>
                        )
                }

                </Stepper>

                <div style={{ marginTop: '3%' }}>
                    <HandleSteps position={stepPosition} />
                </div>
            </Stack>

            <Loading open={isLoading} />

            <EditarComboModal 
            open={openEditComida}
            setOpen={setOpenEditComida}
            control={control}
            funcAgregarNuevaComida={funcAgregarNuevaComida}
            funcUpdateComboSelected={funcUpdateComboSelected}
            categoriasComidasState={categoriasComidasState}
            />
        </Encabezado>
  )
}
